import {
  HttpEventType,
  HttpHandlerFn,
  HttpRequest,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize, tap } from 'rxjs';
import { ExecutingTaskMonitorService } from '../services/executing-task-monitor.service';
import { ImageType } from '../shared/spinner-full-page/model/image-type.enum';

export function manageSpinnerStateInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
) {
  const executingTaskSvc = inject(ExecutingTaskMonitorService);

  executingTaskSvc.showFullPageSpinner.next(true);

  const newReq = req.clone({});
  return next(newReq).pipe(
    tap((event) => {
      if (event.type === HttpEventType.Response) {
        try {
          const id = req.headers.get('x-cdi-id');
          const index = executingTaskSvc.executingTasks.findIndex(
            (f) => f.id == id,
          );
          if (index != -1) {
            executingTaskSvc.executingTasks[index].statusImage =
              ImageType.Success;
          }
        } catch (error) {
          console.error('updateImage', error);
        }
        finalize(() => {
          executingTaskSvc.showFullPageSpinner.next(false);
          try {
            const id = req.headers.get('x-cdi-id');
            const index = executingTaskSvc.executingTasks.findIndex(
              (f) => f.id == id,
            );
            if (index != -1) {
              const elapsed =
                new Date().getTime() -
                (executingTaskSvc.executingTasks[index].startTime ?? 0);
              executingTaskSvc.executingTasks[index].duration = elapsed;
            }
          } catch (error) {
            console.error('updateImage', error);
          }
        });
        executingTaskSvc.showFullPageSpinner.next(false);
      }
    }),
  );
}
